import repository from "@/api/web-api/repository";
import resources from "./resources";

export default {
  getScreens: async () => {
    const PROD_URL = 'https://geo-eip.meteo.ru/monitoring/api/v1/monitors/list';

    const url = process.env.VUE_APP_MODE === 'production' ? PROD_URL : resources.monitoring.screens;

    return await repository.instance.get(url);
  }
}
